<template>
  <div class="settings-page d-flex flex-column">
    <PageHeader title="Single Sign-On" />
    <div
      class="settings-page__body d-flex flex-column align-items-center i-px-12 i-py-11"
    >
      <div class="d-flex justify-content-center w-100">
        <div class="settings-page-view">
          <div v-if="isOrgAdmin">
            <identity-providers ref="identityProviders" />
            <router-view />
          </div>
          <empty-page v-else type="permission"></empty-page>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IdentityProviders from './IdentityProviders';
import { mapGetters } from 'vuex';
import EmptyPage from '@/shared/components/EmptyPage.vue';
import PageHeader from '@/V2/components/PageHeader.vue';

export default {
  components: {
    EmptyPage,
    PageHeader,
    'identity-providers': IdentityProviders,
  },
  computed: {
    ...mapGetters({
      isOrgAdmin: 'isOrgAdmin',
    }),
  },
  mounted() {
    if (this.isOrgAdmin) {
      this.$store.dispatch('getIdentityProvider');
    }
  },
};
</script>

<style lang="scss">
.message-card {
  border: 1px $color-almost-black-60 solid;
  border-radius: 2px;
  background: $color-off-white;
  padding: 20px;
}
</style>
